<app-template>

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
        <div class="main-payment">
            <h1><p>
                MI CARRITO
            </p></h1>
        </div>

        <div class="info">
            <h2><p class="max-width">Para completar tu compra<span>, verifica tus productos <br>
      o agrega más a tu carrito.</span></p></h2>
        </div>

        <div class="payment-content">
            <div class="container max-width">
                <div class="header">
                    <div class="text">
                        <p>Paquetes: </p>
                    </div>
                    <div class="number">
          <span>
            <mat-icon>shopping_cart</mat-icon> ({{totalItems}})
          </span>
                    </div>
                </div>
                <mat-divider></mat-divider>
                <div class="products-list">
                    <ng-container *ngFor="let x of productsList.length | fill ; let i = index">
                        <div class="product-item">
                            <div class="quantity">
                                <div class="container" *ngIf="productsList[i].type != 'anual' ">
                                    {{productsList[i].quantity}}
                                </div>
                                <div class="container"
                                     *ngIf="productsList[i].type == 'anual' && productsList[i].product === 'FAD® PERSONAL'">
                                    <mat-form-field appearance="outline">
                                        <mat-select [(ngModel)]="tranSelect" placeholder="Selecciona" required>
                                            <mat-option>--</mat-option>
                                            <mat-option *ngFor="let trans of numtransaction" [value]="trans"
                                                        (click)="setTransacciones(trans, productsList[i])">{{trans + ' transacciones.'}}</mat-option>
                                        </mat-select>
                                        <mat-error>Campo requerido</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="products">
                                <div class="text-products">
                                    <p class="principal">{{productsList[i].product}}
                                        - {{productsList[i].subscription}}</p>
                                    <p class="secondary">{{productsList[i].usuarios}} {{productsList[i].usuariosLabel}}
                                        - {{getTransacciones(productsList[i])}}
                                        - {{productsList[i].transactionType}}</p>
                                    <p class="secondary" *ngIf="productsList[i].type == 'anual' && productsList[i].product === 'FAD® PERSONAL'">
                                        <span style="font-weight: bold">Precio por transacción: </span>$ {{getPriceCentavos(productsList[i].pricing / productsList[i].transactions) | formatoMil }} {{productsList[i].pricingInfo}}
                                    </p>
                                </div>
                            </div>
                            <div class="price">
                                <p>
                                    $ {{getPriceCentavos(productsList[i].pricing) | formatoMil }} {{productsList[i].pricingInfo}}</p>
                                <div class="line"></div>
                                <mat-icon (click)="deleteItem(productsList[i])">close</mat-icon>
                            </div>
                        </div>
                    </ng-container>
                </div>

            </div>

            <div class="container max-width">

                <div class="line-steps" *ngIf="steps.accountStep.isNext">
                    <div class="step active"></div>
                    <div class="step"></div>
                    <div class="step"></div>
                    <div class="step"></div>
                </div>

                <div class="line-steps" *ngIf="!steps.accountStep.isNext && steps.methodStep.isNext">
                    <div class="step"></div>
                    <div class="step active"></div>
                    <div class="step"></div>
                    <div class="step"></div>
                </div>

                <div class="line-steps" *ngIf="!steps.methodStep.isNext && steps.billingStep.isNext">
                    <div class="step"></div>
                    <div class="step"></div>
                    <div class="step active"></div>
                    <div class="step active"></div>
                </div>

                <!-- CONTINUAR PAGO SE MOSTRARAN LOS INPUTS PARA LA COMPRA -->
                <div class="payment-steps">
                    <div class="forms">
                        <app-create-account
                                [active]="steps.accountStep.isNext || steps.accountStep.completed"></app-create-account>
                        <mat-divider class="margin-plus"></mat-divider>
                        <app-payment-method [(methodData)]="paymentMethod" (paypalMethod)="preparePaypal()"
                                            [active]="steps.methodStep.isNext || steps.methodStep.completed"></app-payment-method>
                        <mat-divider class="margin-plus"></mat-divider>
                        <app-billing-info></app-billing-info>
                        <mat-divider class="margin-plus"></mat-divider>
                    </div>

                    <div class="preview">
                        <img src="assets/images/fad_logo_black.png" alt="Logo" [routerLink]="['/']">
                        <div class="final-summary">
                            <div class="item">
                                <div class="quantity"><p><span>Cantidad</span></p></div>
                                <div class="price"><p><span>Producto</span></p></div>
                            </div>

                            <ng-container *ngFor="let product of productsList">
                                <div class="item">
                                    <div class="quantity"><p><span>{{product.quantity}}</span></p></div>
                                    <div class="price"><p>
                                        <span>{{product.product}} - {{product.subscription}}</span><br>
                                        {{product.usuarios}} {{product.usuariosLabel}} - {{getTransacciones(product)}}
                                        - {{product.transactionType}}</p>
                                        <br>
                                    </div>
                                    <mat-divider class="margin-plus"></mat-divider>
                                </div>
                            </ng-container>
                            <div class="item">
                                <div class="quantity" *ngIf="complementsAdd"><p><span>Complementos:</span></p></div>
                            </div>
                            <br>
                            <ng-container *ngFor="let complements of productsList[0].complements">
                                <div class="item" *ngIf="complements.isAdd">
                                    <div class="quantity"><p><span>{{complements.quantity}}</span></p></div>
                                    <div class="price"><p>
                                        <span>{{complements.name}}</span><br>
                                        {{complements.description}}</p>
                                        <br>
                                    </div>
                                    <mat-divider class="margin-plus"></mat-divider>
                                </div>
                            </ng-container>
                            <app-promotional-code></app-promotional-code>
                            <mat-divider class="margin-plus"></mat-divider>
                            <div class="final-price" *ngIf="this.sessionService.getCountryData()">
                                <p class="label">Subtotal: </p>
                                <p class="price">
                                    <span>$ </span>{{ (getTotalDescuento() === null ? getTotal() : getTotalDescuento()) | formatoMil }}
                                    MXP </p>
                            </div>
                            <div class="final-price" *ngIf="this.sessionService.getCountryData()">
                                <p class="label">IVA: </p>
                                <p class="price">
                                    <span>$ </span>{{ (getTotalDescuento() === null ? getIVA(getTotal() * .16) : getIVA(getTotalDescuento() * .16)) | formatoMil }}
                                    MXP </p>
                            </div>
                            <div class="final-price" *ngIf="this.sessionService.getCountryData()">
                                <p class="label">Total: </p>
                                <p class="price">
                                    <span>$ </span>{{ (getTotalDescuento() === null ? getTotalIVA(getTotal(1)) : getTotalIVA(getTotalDescuento())) | formatoMil }}
                                    MXP</p>
                            </div>
                            <div class="final-price" *ngIf="!this.sessionService.getCountryData()">
                                <p class="label">Total: </p>
                                <p class="price">
                                    <span>$ </span>{{ (getTotalDescuento() === null ? getTotalIVA(getTotal(1)) : getTotalIVA(getTotalDescuento())) | formatoMil }}
                                    USD</p>
                            </div>
                            <br>
                            <div class="error" *ngIf="loader">
                                Por favor espere, estamos procesando su compra.
                                <br><br>
                                <img src="assets/images/loader.gif">
                            </div>
                            <div class="final-action">
                                <button id="completar_compra_fad" *ngIf="!loader" (click)="payment()" mat-raised-button
                                        class="black-button"
                                        [disabled]="!isComplete()">PAGAR AHORA
                                </button>
                            </div>
                            <div class="error" *ngIf="errorData != null">
                                {{errorData}}
                            </div>
                            <div class="error">
                                <img src="assets/images/seguridad.png" alt="">
                            </div>
                            <p class="little-info">
                                Al dar clic en “pagar ahora”, estarás aceptando nuestros <span style="cursor: pointer"
                                                                                               routerLink="/terminos-y-condiciones">Términos y Condiciones</span>
                                así como nuestra <span
                                    [routerLink]="['/aviso-de-privacidad']">Política de privacidad</span>
                            </p>
                            <p class="help"><span [routerLink]="['/como-empezar-a-firmar-digitalmente']">¿necesitas ayuda?</span>
                                | <span
                                        [routerLink]="['/preguntas-frecuentes-de-la-firma-digital-fad']">Preguntas frecuentes</span>
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf="isMobile === true  || isTablet === true">
        <div class="box-container">
            <div class="box-img">
                <img class="img-prin" src="assets/images/m/comprafad.png">
            </div>

            <div class="content-res">
                <div class="aux">
                    <h1>Mi <span>carrito</span></h1>
                    <p class="text">
                        Tienes <strong>{{totalItems}} {{totalItems === 1 ? 'producto' : 'productos' }}</strong> en tu
                        carrito.
                    </p>
                    <h2><p class="text">
                        Para completar tu compra<strong>, verifica tus productos o agrega más a tu carrito.</strong>
                    </p></h2>

                </div>
            </div>

            <div class="content-res">
                <p class="title-header">Paquete:</p>
                <mat-divider></mat-divider>
                <ng-container *ngFor="let x of productsList.length | fill ; let i = index">
                    <div class="box-product">
                        <div class="product-item">
                            <div class="products">
                                <div class="header">
                                    <div class="principal">
                                        <p class="title"><strong>{{productsList[i].product}}</strong>
                                            - {{productsList[i].subscription}}</p>
                                        <p class="title-second">{{productsList[i].usuarios}} {{productsList[i].usuariosLabel}}
                                            - {{getTransacciones(productsList[i])}}</p>
                                    </div>
                                    <mat-icon (click)="deleteItem(productsList[i])">close</mat-icon>
                                </div>
                                <div class="header">
                                    <p class="title-second" *ngIf="productsList[i].type == 'anual' && productsList[i].product === 'FAD® PERSONAL'">
                                        <span>Precio por transacción: </span>$ {{getPriceCentavos(productsList[i].pricing / productsList[i].transactions) | formatoMil }} {{productsList[i].pricingInfo}}
                                    </p>
                                </div>
                                <div class="num-trans"
                                     *ngIf="productsList[i].type == 'anual' && productsList[i].product === 'FAD® PERSONAL'">
                                    <p><span>Transacciones que necesitas:</span></p>
                                    <div class="container">
                                        <mat-form-field appearance="outline">
                                            <mat-select [(ngModel)]="tranSelect" placeholder="Selecciona" required>
                                                <mat-option>--</mat-option>
                                                <mat-option *ngFor="let trans of numtransaction" [value]="trans"
                                                            (click)="setTransacciones(trans, productsList[i])">{{trans + ' transacciones.'}}</mat-option>
                                            </mat-select>
                                            <mat-error>Campo requerido</mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="price">
                                    <p>Precio:</p>
                                    <p>
                                        $ {{getPriceCentavos(productsList[i].pricing)  | formatoMil }} {{productsList[i].pricingInfo}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

            </div>

            <div class="box-light-fondo">
                <div class="wrapper">
                    <div class="content-res" style="padding-bottom: 10px;">
                        <p class="light">
                            ¿Para pagar, <span>crea una cuenta o inicia sesión:</span>
                        </p>
                    </div>
                    <app-create-account
                            [active]="steps.accountStep.isNext || steps.accountStep.completed "></app-create-account>
                    <mat-divider class="margin-plus"></mat-divider>
                    <app-payment-method [(methodData)]="paymentMethod" (paypalMethod)="preparePaypal()"
                                        [active]="steps.methodStep.isNext || steps.methodStep.completed"></app-payment-method>
                    <mat-divider class="margin-plus"></mat-divider>
                    <app-billing-info
                            [active]="steps.billingStep.isNext || steps.billingStep.completed"></app-billing-info>
                    <mat-divider class="margin-plus"></mat-divider>
                </div>
                <div class="box-product" style="font-size: 20px; color: white">
                    <p class="title-header" style="padding-left: 30px">Paquete a pagar:</p>
                    <mat-divider class="margin-plus" style="background: white"></mat-divider>
                    <ng-container *ngFor="let x of productsList.length | fill ; let i = index">
                        <div class="products">
                            <div class="check-product">
                                <p><span>{{productsList[i].product}}</span> - {{productsList[i].subscription}}:</p>
                                <p class="price" *ngIf="this.sessionService.getCountryData()">
                                    $ {{productsList[i].pricing | formatoMil }}
                                    .00 {{productsList[i].pricingInfo}}</p>
                                <p class="price" *ngIf="!this.sessionService.getCountryData()">
                                    $ {{productsList[i].pricing | formatoMil }} {{productsList[i].pricingInfo}}</p>
                            </div>
                        </div>
                    </ng-container>
                    <mat-divider class="margin-plus" style="background: white"></mat-divider>
                    <app-promotional-code></app-promotional-code>
                    <mat-divider class="margin-plus" style="background: white"></mat-divider>
                    <div class="content-res" style="color: white">
                        <div class="final-price" *ngIf="this.sessionService.getCountryData()">
                            <p>Subtotal: </p>
                            <p>
                                <span>$ {{ (getTotalDescuento() === null ? getTotal() : getTotalDescuento()) | formatoMil }}
                                    MXP </span></p>
                        </div>
                        <div class="final-price" *ngIf="this.sessionService.getCountryData()">
                            <p>IVA: </p>
                            <p>
                                <span>$ {{ (getTotalDescuento() === null ? getIVA(getTotal() * .16) : getIVA(getTotalDescuento() * .16)) | formatoMil }}
                                    MXP </span></p>
                        </div>
                        <div class="final-price" *ngIf="this.sessionService.getCountryData()">
                            <p>Total: </p>
                            <p>
                                <span>$ {{ (getTotalDescuento() === null ? getTotalIVA(getTotal(1)) : getTotalIVA(getTotalDescuento())) | formatoMil }}
                                    MXP </span></p>
                        </div>
                        <div class="final-price" *ngIf="!this.sessionService.getCountryData()">
                            <p>Total: </p>
                            <p>
                                <span>$ {{ (getTotalDescuento() === null ? getTotalIVA(getTotal(1)) : getTotalIVA(getTotalDescuento())) | formatoMil }}
                                    USD </span></p>
                        </div>
                        <div class="edit-btn">
                            <button id="completar_compra_fad_movil" *ngIf="!loader" (click)="payment()"
                                    mat-raised-button
                                    class="black-button-data"
                                    [disabled]="!isComplete()">PAGAR AHORA
                            </button>
                        </div>
                        <div class="error" *ngIf="loader">
                            Por favor espere, estamos procesando su compra.
                            <br><br>
                            <img style="width: 60%; margin: 0 20%" src="assets/images/loader.gif">
                        </div>
                        <div class="error" *ngIf=" errorData ">
                            {{errorData}}
                        </div>
                        <div class="error" style="background-color: white;">
                            <img src="assets/images/seguridad.png" alt="">
                        </div>
                        <p class="text" style="font-size: 14px; padding: 0 30px; text-align: center">
                            Al dar clic en “pagar ahora”, estarás aceptando nuestros <span style="cursor: pointer"
                                                                                           routerLink="/terminos-y-condiciones">Términos y Condiciones</span>
                            así como nuestra <span style="cursor: pointer"
                                                   [routerLink]="['/aviso-de-privacidad']">Política de privacidad.</span>
                        </p>
                        <p class="text" style="font-size: 14px; padding: 0 30px; text-align: center"><span
                                style="cursor: pointer" [routerLink]="['/como-empezar-a-firmar-digitalmente']">¿necesitas ayuda?</span>
                        </p>
                        <p class="text" style="font-size: 14px; padding: 0 30px; text-align: center"><span
                                style="cursor: pointer"
                                [routerLink]="['/preguntas-frecuentes-de-la-firma-digital-fad']">Preguntas frecuentes</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</app-template>
